import { combineReducers } from 'redux'

import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'

import * as actions from '../actions'
import { ILastWinsState } from '../types'

export default combineReducers<ILastWinsState['communications']>({
  getSlotsLastWins: makeCommunicationReducer(actions.getSlotsLastWins),
  getPlayerPrivacySettings: makeCommunicationReducer(actions.getPlayerPrivacySettings),
  changePrivacy: makeCommunicationReducer(actions.changePrivacy),
})
